import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useReducer, useRef, useState } from "react";
import { Button, FormGroup, Modal } from "react-bootstrap";
import Loader from "react-loader-spinner";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import { updateAllProductsPrice } from "../store/api/GetAllProduct";
import NewNumberInput from "../../Components/NewNumberInput";
import { Check2Square } from "react-bootstrap-icons";
import { searchHolders, getAllProductTypesNew } from "../store/api/GetAllProduct";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { useDispatch, useSelector } from "react-redux";
import { faListOl, faTimes } from "@fortawesome/free-solid-svg-icons";
import { getAllProductMainGroups, getProductGroups } from "../../store/api/GetAllProduct";

export default function ModalUpdateProductsPrice(props) {
    const dispatch = useDispatch();
    const { popData, setPopData } = props;
    const [pending, setPending] = useState(false);
    const [typeList, setTypeList] = useState();
    const [holderList, setHolderList] = useState();
    const [productGroups, setProductGroups] = useState([]);
    const [mainGroups, setMainGroups] = useState([]);
    const { show } = popData;
    const [productsPriceInfo, setProductPriceInfo] = useState({ PriceName: "SalePrice", IsPercent: true });
    const { settings } = useSelector(state => {
        return {
            settings: state.SystemSettingsReducer.systemSettings
        }
    });
    const settingNames = ['ProductGrouppingType'];
    const pgType = Number(settings?.find?.(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? -1);
    function close() {
        setPopData({ show: false });
    }
    function updatePrice() {
        if (pending) {
            return false;
        }

        if (!productsPriceInfo.Value) {
            setErrorDialog(dispatch, "مبلغ/ درصد وارد نشده است.");
            return;
        }

        const onUpdate = (res) => {
            setPending(!(res.Data || res.Error));

            if (res.Data) {
                setErrorDialog(dispatch, res.Data, "ویرایش قیمت ها");

            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ویرایش قیمت ها")
            }
        }
        setPending(true);
        updateAllProductsPrice(productsPriceInfo, onUpdate);
    }
    function onMGSelect(e) {
        if (Number(e.target.value) > 0) {
            setProductPriceInfo({ ...productsPriceInfo, MainGroupID: e.target.value });
            getProductGroups(e.target.value, setProductGroups);
        }
        else {
            setProductGroups([]);
        }
    }
    function handlePriceChange(e) {
        let value = Number(e.target.value);
        // if (productsPriceInfo.IsPercent) {
        //     
        //     if (value > 100) {
        //         value = 100;
        //     }
            setProductPriceInfo({ ...productsPriceInfo, Value: value });
        //}
    }
    useEffect(() => {
        if (show) {
            dispatch(getSystemSettings(settingNames));
            getAllProductTypesNew(setTypeList);


        }
    }, [show])
    useEffect(() => {
        if (!show) {
            return;
        }
        if (pgType === 1) {
            getAllProductMainGroups(setMainGroups);
        }
        else if (pgType === 0) {

            searchHolders("", "", setHolderList);
        }
    }, [show, pgType])
    return (
        <Modal size="sm" show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faListOl} size="lg" />&nbsp;
                    بروزرسانی قیمت کالا ها
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle" style={{ paddingTop: "0px" }}>
                <FormGroup>
                    {holderList === "PENDING" &&
                        <div className="form-control">
                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                        </div>
                    }
                    {holderList && Array.isArray(holderList) &&
                        <select name="HolderID" className="form-control" onChange={e => setProductPriceInfo({ ...productsPriceInfo, HolderID: e.target.value })}
                        >
                            <option value="">مارک کالا را انتخاب کنید</option>
                            {holderList.map((item, i) => <option key={i} value={item.ID}>{item.HolderName}</option>)}
                        </select>
                    }
                </FormGroup>
                {pgType !== 1 ?
                    <FormGroup>
                        {typeList === "PENDING" &&
                            <div className="form-control">
                                <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                            </div>
                        }
                        {typeList && Array.isArray(typeList) &&
                            <select className="form-control" onChange={e => setProductPriceInfo({ ...productsPriceInfo, TypeID: e.target.value })}
                            >
                                <option value="">نوع کالا را انتخاب کنید</option>
                                {typeList.map((item, i) => <option key={i} value={item.ID}>{item.Name}</option>)}
                            </select>
                        }
                    </FormGroup> :
                    <>
                        <FormGroup md={2} xs={6} className='form-group'>
                            <select className='tableRowInput scThin' name='MainGroupID' onChange={onMGSelect}>
                                <option value=''>گروه اصلی</option>
                                {Array.isArray(mainGroups) &&
                                    mainGroups.map((mg, i) => <option key={i} value={mg.MainGroupID}>{mg.MainGroupName}</option>)}
                            </select>
                        </FormGroup>
                        <FormGroup md={2} xs={6} className='form-group'>
                            <select className='tableRowInput scThin' onChange={e => setProductPriceInfo({ ...productsPriceInfo, GroupID: e.target.value })}>
                                <option value=''>گروه فرعی</option>
                                {Array.isArray(productGroups) &&
                                    productGroups.map((pg, i) => <option key={i} value={pg.GroupID}>{pg.GroupName}</option>)}
                            </select>
                        </FormGroup>
                    </>
                }

                <FormGroup>
                    <NewNumberInput onChange={handlePriceChange} placeholder="مبلغ/درصد" />
                </FormGroup>
                <FormGroup>
                    <select className="form-control" onChange={e => setProductPriceInfo({ ...productsPriceInfo, IsPercent: e.target.value })}>
                        <option value={true}>درصد</option>
                        <option value={false}>مبلغ ثابت</option>
                    </select>
                </FormGroup>
                <FormGroup>
                    <select className="form-control" onChange={e => setProductPriceInfo({ ...productsPriceInfo, PriceName: e.target.value })}>
                        <option value="SalePrice">قیمت فروش</option>
                        <option value="SalePrice3">قیمت فروش سوم</option>
                        <option value="GauranteeSalePrice">قیمت فروش گارانتی</option>
                    </select>
                </FormGroup>
                <Button className="group-Btn mt-2" variant="info" onClick={updatePrice} disabled={pending}><Check2Square size={18} />&nbsp;انجام بروزرسانی</Button>
            </Modal.Body>
        </Modal>
    )
}